import {memo} from 'react'

import NestedBuildTypeLine from '../../../common/NestedSubprojectsAndBuildTypes/BuildTypeLine/BuildTypeLine'

import BuildProblemList from './BuildProblemList/BuildProblemList'
import type {ContainerProps} from './BuildTypeLine.types'

import styles from './BuildTypeLine.css'

function BuildTypeLine(props: ContainerProps) {
  const {projectId, buildTypeId, buildProblems} = props
  return (
    <NestedBuildTypeLine {...props}>
      <div className={styles.container}>
        <BuildProblemList
          projectId={projectId}
          buildTypeId={buildTypeId}
          buildProblems={buildProblems}
        />
      </div>
    </NestedBuildTypeLine>
  )
}

export default memo(BuildTypeLine)
